import { initGlobalState } from 'qiankun'
import router from '@/router'
import store from './store'
import { confirmLogin } from '@/utils/util'
import { curriedConfig, mainAddTab, mainRemoveTab, mainUpdateTab, mainRouterPush } from '@/utils/microTools'
const isPro = true

const props = {
  mainGetters: store.getters,
  parentCommit: store.commit.bind(store),
  confirmLogin,
  mainAddTab,
  mainUpdateTab,
  mainRemoveTab,
  mainRouterPush,
  mainRouter: router,
  is404: undefined,
  to404: null,
  notThisApp: undefined,
  showMicroApp: store.getters.showMicroApp
}

// 针对灵心的props
const agentProps = {
  sysCode: 'SYS_QIAOCAI',
  mainAddTab,
  mainUpdateTab,
  mainRemoveTab,
  mainRouterPush
}

export const config = [
  {
    name: 'admin',
    code: 'UCS',
    entry: generateEntry({ proPath: '/b/', localPath: '/index', port: '8000' }),
    container: '#container_admin',
    path: generateActiveRule('/admin/index'),
    rootPath: '/admin',
    props,
    cache: false
  },
  {
    name: 'fund',
    code: 'CAPITAL',
    entry: generateEntry({ proPath: '/fund/fund_settlement/', localPath: '/fund_settlement/', port: '8001' }),
    container: '#container_fund',
    path: generateActiveRule('/fund/fund_settlement'),
    rootPath: '/fund',
    props,
    prefetch: true
  },
  {
    name: 'finsaas-ras',
    code: 'RAS',
    entry: generateEntry({ proPath: '/finsaas-ras/', localPath: '/finsaas-ras/', port: '8002' }),
    container: '#container_finsaas-ras',
    path: generateActiveRule('/finsaas-ras'),
    rootPath: '/finsaas-ras',
    props,
    cache: false
  },
  {
    name: 'fins',
    code: 'FINANCE',
    entry: generateEntry({ proPath: '/fins/', localPath: '/', port: '8003' }),
    container: '#container_fins',
    path: generateActiveRule('/fins'),
    rootPath: '/fins',
    props,
    cache: true,
    prefetch: true
  },
  {
    name: 'fas',
    code: 'AMS',
    entry: generateEntry({ proPath: '/fas/', localPath: '/', port: '8005' }),
    container: '#container_fas',
    path: generateActiveRule('/fas'),
    rootPath: '/fas',
    props,
    cache: true,
    prefetch: true
  },
  {
    name: 'ems',
    code: 'REIM',
    entry: generateEntry({ proPath: '/ems/', localPath: '/', port: '8004' }),
    container: '#container_ems',
    path: generateActiveRule('/ems'),
    rootPath: '/ems',
    props,
    cache: true
  },
  {
    name: 'report',
    code: 'MRS',
    entry: generateEntry({ proPath: '/report/', localPath: '/', port: '8006' }),
    container: '#container_report',
    path: generateActiveRule('/report'),
    rootPath: '/report',
    props,
    cache: true
  },
  {
    name: 'engine',
    code: 'AES',
    entry: generateEntry({ proPath: '/engine/', localPath: '/', port: '8888' }),
    container: '#container_engine',
    path: generateActiveRule('/engine'),
    rootPath: '/engine',
    props,
    cache: true
  },
  {
    name: 'aps',
    code: 'APS',
    entry: generateEntry({ proPath: '/aps/', localPath: '/', port: '8889' }),
    container: '#container_aps',
    path: generateActiveRule('/aps'),
    rootPath: '/aps',
    props,
    cache: true
  },
  {
    name: 'scm',
    code: 'SCM',
    entry: generateEntry({ proPath: '/scm/', localPath: '/', port: '8009' }),
    container: '#container_scm',
    path: generateActiveRule('/scm/homePage'),
    rootPath: '/scm',
    props,
    cache: true
  },
  {
    name: 'bi',
    code: 'app_201',
    entry: generateEntry({ proPath: '/bi/', localPath: '/', port: '8010' }),
    container: '#container_bi',
    path: generateActiveRule('/bi'),
    rootPath: '/bi',
    props,
    cache: true,
    prefetch: true
  },
  {
    name: 'agent',
    code: 'app_1585',
    entry: generateEntry({ proPath: '/agent/' }),
    container: '#container_agent',
    path: generateActiveRule('/agent'),
    rootPath: '/agent',
    props: agentProps,
    cache: true,
    prefetch: true
  },
  {
    name: 'crs',
    code: 'app_1667',
    entry: generateEntry({ proPath: '/crs/', localPath: '/', port: '8007' }),
    container: '#container_crs',
    path: generateActiveRule('/crs'),
    rootPath: '/crs',
    props,
    cache: true
  }
]

export const startConfig = {
  singular: false,
  sandbox: { experimentalStyleIsolation: true }
}

export const actions = initGlobalState({
  clientWidth: 0,
  routers: {},
  collapsed: false,
  proxyList: [],
  accountBook: null, // 总账菜单参数
  subEvent: null,
  defaultCompany: null,
  microAppRoutes: {},
  fullAccountInfo: {},
  // 以下是为了灵心需要的state
  closeLoading: false,
  currentAppRoute: {},
  appRoute: [],
  cachedRoute: [],
  microAppMap: {}
})

export function initMainState () {
  actions.onGlobalStateChange((state) => {
    store.commit('SET_MICRO_APP_LOADING', false)
    for (const key in state) {
      switch (key) {
        case 'proxyList':
          store.commit('SET_PROXY_LIST', state.proxyList)
          break
        // case 'routers':
        //   store.commit('setRouters', state.routers)
        //   break
        case 'collapsed':
          store.commit('TOGGLE_COLLAPSED', state.collapsed)
          break
        case 'accountBook':
          store.commit('setAccountBook', state.accountBook)
          break
        case 'defaultCompany':
          console.log('设置默认公司', state.defaultCompany)
          store.commit('setDefaultCompany', state.defaultCompany)
          break
        default:
          break
      }
    }
    console.log('onGlobalStateChange', state)
  })
}

function generateEntry ({ proPath, localPath, port }) {
  if (proPath === '/agent/') {
    const env = process.env.VUE_APP_ENV || 'pro'
    const bases = {
      dev: 'https://dev-ai.wehichina.com/',
      test: 'https://test-ai.wehichina.com/',
      pre: 'https://pre-ai.wehichina.com/',
      pro: 'https://ai.wehichina.com/'
    }
    return bases[env]
  } else {
    const { hostname, protocol } = document.location
    const isLocalhost = ['localhost', '127.0.0.1'].includes(hostname)
    return `${protocol}//${hostname}${isLocalhost ? `:${port}` : ''}${isPro ? proPath : localPath}`
  }
}

function generateActiveRule (path) {
  path = (isPro && !path.match(/^\/ucs\//)) ? `/ucs${path}` : path
  return path
}

const currentConfig = curriedConfig(config)

const is404 = (appName, path) => {
  const current = currentConfig(path)
  console.log(current)
  return (appName === current?.name)
}

const notThisApp = (appName, path) => {
  if (appName === 'fins' && path.startsWith('/aas-ras')) {
    path = '/finsass-ras'
  }
  const current = currentConfig(path)
  return (appName !== current?.name)
}

const to404 = () => router.replace('/404')

props.is404 = is404
props.to404 = to404
props.notThisApp = notThisApp
